import {
  PLAYER_OPTIONS_SHOW_EPG,
  PLAYER_OPTIONS_HIDE_EPG,
} from 'containers/Player/actions/optionButtons/constants';

const initialState = {
  isOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYER_OPTIONS_SHOW_EPG:
      return { isOpen: true };
    case PLAYER_OPTIONS_HIDE_EPG:
      return { isOpen: false };
    default:
      return state;
  }
};
